import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { Typography } from '@mui/material';

import { useTranslate } from 'src/locales';

import { Image } from 'src/components/image';

import { useChannelContext } from '../hooks';

export function Step4() {
  const { t } = useTranslate('translation');

  const { onChangeStep } = useChannelContext();
  // =============================================================================
  return (
    <Box sx={{ height: '95%', display: 'flex', flexDirection: 'column' }}>
      <Typography variant="h3" sx={{ textAlign: 'center', mb: 3 }}>
        {t('CHANNEL_CREATED_SUCCESSFULLY')}
      </Typography>
      <Box sx={{ textAlign: 'center', my: 2 }}>
        <Image
          src="/assets/icons/channel/create-channel.svg"
          alt="channel svg"
          sx={{ width: '400px' }}
        />
      </Box>
      <Box sx={{ flexGrow: 1 }} />
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        <Box>
          <Button
            fullWidth
            size="small"
            type="submit"
            variant="contained"
            onClick={() => onChangeStep('next')}
          >
            {t('FINISH')}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
